import React from "react";
import {Link} from "react-router-dom";
import Modal from "../../Modal";

const LichaamMunchausenByProxySyndroom = () => (
    <Modal>
        <div>
            <section id={'mbp'}>
                <h1>Munchausen-by-proxysyndroom</h1>

                <p className={'text'}>
                    Kenmerkend voor het münchhausen-by-proxysyndroom is dat de plegers bij
                    een kind fysieke of psychische signalen of symptomen voorwenden of een
                    verwonding of ziekte veroorzaken of verergeren.
                </p>

                <p className={'text'}>
                    Plegers doen naar anderen voorkomen alsof het kind ziek, beperkt of gewond is. De
                    pleger verzint of overdrijft verschijnselen of rapporteert specifieke
                    gedragingen/situaties die zich alleen voordoen in aanwezigheid van de pleger.
                    Plegers kunnen anderen misleiden door patiëntdossiers aan te passen, of medisch
                    onderzoek te verstoren, bijvoorbeeld door bloed of suiker aan de urine van een kind
                    toe te voegen. Ook kunnen ze een kind een te hoge dosis medicatie geven, gifstoffen
                    toedienen, uithongeren of verstikken.
                </p>
            </section>
        </div>
    </Modal>
);


export default LichaamMunchausenByProxySyndroom;
